// Asset Work Record Status Constants
export const ASSET_WORK_STATUS = {
  PENDING_EXECUTION_APPROVAL: 'pending_execution_approval',
  EXECUTION_APPROVED: 'execution_approved',
  IN_PROGRESS: 'in_progress',
  PENDING_COMPLETION_APPROVAL: 'pending_completion_approval',
  COMPLETED: 'completed',
  SKIPPED: 'skipped',
  FAILED: 'failed'
} as const;

export type AssetWorkStatus = typeof ASSET_WORK_STATUS[keyof typeof ASSET_WORK_STATUS];

// Status Labels for UI
export const STATUS_LABELS = {
  [ASSET_WORK_STATUS.PENDING_EXECUTION_APPROVAL]: 'Chờ duyệt thực hiện',
  [ASSET_WORK_STATUS.EXECUTION_APPROVED]: 'Đã duyệt thực hiện',
  [ASSET_WORK_STATUS.IN_PROGRESS]: 'Đang thực hiện',
  [ASSET_WORK_STATUS.PENDING_COMPLETION_APPROVAL]: 'Chờ duyệt hoàn thành',
  [ASSET_WORK_STATUS.COMPLETED]: 'Hoàn thành',
  [ASSET_WORK_STATUS.SKIPPED]: 'Bỏ qua',
  [ASSET_WORK_STATUS.FAILED]: 'Thất bại'
} as const;

// Status Colors for UI
export const STATUS_COLORS = {
  [ASSET_WORK_STATUS.PENDING_EXECUTION_APPROVAL]: 'orange',
  [ASSET_WORK_STATUS.EXECUTION_APPROVED]: 'blue',
  [ASSET_WORK_STATUS.IN_PROGRESS]: 'processing',
  [ASSET_WORK_STATUS.PENDING_COMPLETION_APPROVAL]: 'orange',
  [ASSET_WORK_STATUS.COMPLETED]: 'success',
  [ASSET_WORK_STATUS.SKIPPED]: 'default',
  [ASSET_WORK_STATUS.FAILED]: 'error'
} as const;

// Action Labels
export const ACTION_LABELS = {
  COMPLETE: 'Hoàn thành',
  VIEW_DETAIL: 'Xem chi tiết',
  DELETE: 'Xóa',
  QUICK_COMPLETE: 'Hoàn thành nhanh',
  APPROVE: 'Duyệt',
  REJECT: 'Từ chối'
} as const;

// Validation Messages
export const VALIDATION_MESSAGES = {
  COMPLETION_DATE_REQUIRED: 'Ngày hoàn thành là bắt buộc',
  COST_INVALID: 'Chi phí phải là số không âm',
  EMPLOYEE_REQUIRED: 'Vui lòng chọn nhân viên thực hiện',
  WORK_DESCRIPTION_REQUIRED: 'Mô tả công việc là bắt buộc'
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  CREATED: 'Tạo bản ghi tác nghiệp thành công!',
  UPDATED: 'Cập nhật tác nghiệp thành công!',
  COMPLETED: 'Hoàn thành tác nghiệp thành công!',
  DELETED: 'Xóa tác nghiệp thành công!',
  APPROVED: 'Duyệt tác nghiệp thành công!'
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  CREATE_FAILED: 'Tạo bản ghi tác nghiệp thất bại!',
  UPDATE_FAILED: 'Cập nhật tác nghiệp thất bại!',
  COMPLETE_FAILED: 'Không thể hoàn thành tác nghiệp',
  DELETE_FAILED: 'Xóa tác nghiệp thất bại!',
  LOAD_EMPLOYEES_FAILED: 'Không thể tải danh sách nhân viên',
  LOAD_SUPPLIERS_FAILED: 'Không thể tải danh sách nhà cung cấp'
} as const; 